const $ = window.jQuery;

$(document).ready(function() {

    $(window).on('scroll', function() {
        let windownTop = $(window).scrollTop();
        if(windownTop > 0) {
            $('.site-header').removeClass('top');
        } else {
            $('.site-header').addClass('top');
        }
    });

    $('.hamburger').on('click', function(e) {
        $(this).toggleClass('is-active');
        $('.site-header-menu').toggleClass('open');
        $('body').toggleClass('no-scroll');

        if( $('.site-branding').hasClass('hide') ) {
            $('.site-branding').removeClass('hide'); 
        } 

        if( $('.sub-menu-toggle-header').hasClass('show') ) {
            $('.sub-menu-toggle-header').removeClass('show'); 
        }

        if( $('.menu-item-has-children').hasClass('open') ) {
            $('.menu-item-has-children').removeClass('open');
        }

        if( $(this).hasClass('is-active') ) {
            $(this).attr('aria-label', ID_aria.close_menu); 
        } else {
            $(this).attr('aria-label', ID_aria.open_menu); 
        }
    });

    $('.current-menu-ancestor').each(function(e) {
        $(this).addClass('open'); 
    });

    $('.sub-menu-toggle-header').on('click', function(e) {
        if( $(this).hasClass('show') ) {
            $(this).removeClass('show'); 
        }
        if( $('.site-branding').hasClass('hide') ) {
            $('.site-branding').removeClass('hide'); 
        } 
        $('.menu-item-has-children').removeClass('open');
    }); 
    
    $('.site-header .sub-menu-toggle').on('click', function(e) {
        e.stopPropagation();
        $(this).parent().parent('.menu-item').toggleClass('open'); 
        $('.site-branding').toggleClass('hide'); 
        $('.sub-menu-toggle-header').toggleClass('show'); 
        
        if( $(this).parent('.menu-item').hasClass('open') ) {
            $(this).attr('aria-label', ID_aria.close_submenu); 
        } else {
            $(this).attr('aria-label', ID_aria.open_submenu); 
        }
    });

    $('.sub-menu-toggle').on('click', function(e) {
        e.stopPropagation();
        $(this).parent('.menu-item').toggleClass('open'); 
        
        if( $(this).parent('.menu-item').hasClass('open') ) {
            $(this).attr('aria-label', ID_aria.close_submenu); 
        } else {
            $(this).attr('aria-label', ID_aria.open_submenu); 
        }
    });

});
